"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MegaMenuMobileMain = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const context_1 = require("../../context");
const _1 = require(".");
const MegaMenuMobileMain = () => {
    const { megaMenuItems, setSelectedMegaMenuIndex } = (0, react_1.useContext)(context_1.HeaderContext);
    return ((0, jsx_runtime_1.jsx)("ul", { className: "subtitle-lg-moderate flex w-full flex-col px-sm", children: megaMenuItems === null || megaMenuItems === void 0 ? void 0 : megaMenuItems.map((item, index) => ((0, jsx_runtime_1.jsx)(_1.MegaMenuMobileListItem, { caption: item.caption, url: item.type === 'zeroLevel' ? item.url : undefined, onClick: () => setSelectedMegaMenuIndex(index) }, item.caption))) }));
};
exports.MegaMenuMobileMain = MegaMenuMobileMain;
